import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Flex } from 'reflexbox'
import {
  Dialog,
  Tabs,
  Tab,
  Chip,
} from 'react-toolbox'
import CSSModules from 'react-css-modules'

import ConfigList from './ConfigList'
import AddConfig from './AddConfig'

import styles from './styles.scss'

class AddPopup extends Component {
  render() {
    const {
      sources,
      configSelection,
      configSource,
      curConfig,
      children,
      onTogglePopup,
      onUpdateConfig,
      onUpdateConfigSource,
      onAddPart,
      multiSelectable,
      filterStatus,
      enableRvl,
      tableHeadContent,
      onRefreshFilter,
      isEdit,
      setEditPart,
      onEditPart
    } = this.props

    return (
          <Flex styleName='tabWrapper'>
            { children }
            <ConfigList
              sources={sources}
              filterStatus={filterStatus}
              configSelection={configSelection}
              onUpdateConfig={onUpdateConfig}
              onUpdateConfigSource={onUpdateConfigSource}
              multiSelectable={
                /* Not multiSelectable by default */
                typeof this.props.multiSelectable != 'undefined' ? this.props.multiSelectable : false
              }
              enableRvl={
                /* Rvl is disabled by default */
                typeof this.props.enableRvl != 'undefined' ? this.props.enableRvl : false
              }
              tableHeadContent={tableHeadContent}
            />
            <AddConfig
              onTogglePopup={onTogglePopup}
              onUpdateConfig={onUpdateConfig}
              onUpdateConfigSource={onUpdateConfigSource}
              onAddPart={onAddPart}
              onEditPart={onEditPart}
              configSelection={configSelection}
              configSource={configSource}
              curConfig={curConfig}
              onRefreshFilter={onRefreshFilter}
              isEdit={isEdit}
              setEditPart={setEditPart}
            />
          </Flex>
    )
  }
}

AddPopup.propTypes = {
  sources: PropTypes.array.isRequired,
  configSelection: PropTypes.array.isRequired,
  configSource: PropTypes.array.isRequired,
  multiSelectable: PropTypes.bool,
  enableRvl: PropTypes.bool,

  onAddPart: PropTypes.func.isRequired,
  onTogglePopup: PropTypes.func.isRequired,
  onUpdateConfig: PropTypes.func.isRequired,
  onUpdateConfigSource: PropTypes.func.isRequired,
  onRefreshFilter: PropTypes.func.isRequired,

  filterStatus: PropTypes.object.isRequired,
  curConfig: PropTypes.object.isRequired,
  tableHeadContent: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ])
}

export default CSSModules(AddPopup, styles)
